import tinycolor from 'tinycolor2';

const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';

const colors = [
  '#4e0ff9', // purple
  '#31a279', // green
  '#1b68ca', // blue
  '#ffb700', // orange
  '#cc4279', // pink
];

export function avatar(username: string) {
  const charIndex = alphabet.indexOf(username.charAt(0).toLowerCase());
  const colorIndex = charIndex % colors.length;

  const c1 = tinycolor(colors[colorIndex]).lighten(35);
  const c2 = c1.clone().lighten(7.5);
  const textColor = c1.clone().darken(40);

  const svg = `
    <svg width="120" height="120" viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="${c2.toHexString()}" />
          <stop offset="100%" stop-color="${c1.toHexString()}" />
        </linearGradient>
      </defs>
      <rect fill="url(#gradient)" x="0" y="0" width="120" height="120" />
      <text x="60" y="66" transform="translateY(-50%)" fill="${textColor.toHexString()}" text-anchor="middle" dominant-baseline="middle" font-family="Arial" font-size="60">
        ${username.charAt(0).toUpperCase()}
      </text>
    </svg>
  `;

  const blob = new Blob([svg], { type: 'image/svg+xml' });
  const dataURL = URL.createObjectURL(blob);

  return dataURL;
}
